// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"304":"8aef08d2","878":"22cf43af"}[chunkId] + ".chunk.js";
};